export default __webpack_public_path__ + "cc1e6abce12a2e449430bec23022c13e.svg";